<!--begin::Form-->

<div class="auth-panel" [class.investigator-login]="APP_NAME === 'investigator-portal'">
  <!--begin::Heading-->
  <div class="text-center mb-5">
    @if(APP_NAME==='investigator-portal'){
    <div class="investigator-brand">
      <span class="investigator-eyebrow">Coreact Motor</span>
      <img src="assets/media/logos/coreact-investigator-portal.png" alt="Coreact Investigator Portal" class="login-logo" />
    </div>

    }@else if(APP_NAME==='coassess'){
    <img src="assets/coassess-login.png" alt="Login Logo" class="login-logo" />

    }@else{
    <img src="assets/coreact.png" alt="Login Logo" class="login-logo" />
    }

    <div class="flex justify-center items-center gap-3">
      <h3
        class="text-black font-bold my-0 mb-0"
        [attr.role]="APP_NAME === 'investigator-portal' ? 'heading' : null"
        [attr.aria-level]="APP_NAME === 'investigator-portal' ? 1 : null"
      >
        {{ (isMfaStep() ? "AUTH.LOGIN.MFA_TITLE" : "AUTH.LOGIN.TITLE") | translate }}
      </h3>
      <img
        class="cursor-pointer"
        (click)="translateService.toggleLanguage()"
        [src]="translateService.flagUrl()"
        height="15"
        width="15"
        alt=""
        srcset=""
      />
    </div>
  </div>
  <!--end::Heading-->

  @if (!isMfaStep()) {
  <form
    class="form w-full"
    [formGroup]="loginForm"
    novalidate="novalidate"
    (ngSubmit)="submit()"
  >
  <!-- begin::Alert error-->
  @if (hasError()) {
  <div class="mb-lg-15">
    <div class="font-bold text-red-400">The login details are incorrect</div>
  </div>
  }
  <!-- end::Alert error-->

  <!--begin::Form group-->
  <div class="flex flex-col mb-8">
    <label class="form-label font-bold text-black mb-1">{{
      "AUTH.LOGIN.EMAIL" | translate
    }}</label>
    <input
      pInputText
      class="form-control !bg-transparent"
      type="email"
      name="email"
      [attr.aria-label]="APP_NAME === 'investigator-portal' ? ('AUTH.LOGIN.EMAIL' | translate) : null"
      formControlName="email"
      autocomplete="off"
      [ngClass]="{
        'is-invalid': loginForm.controls['email'].invalid,
        'is-valid': loginForm.controls['email'].valid
      }"
    />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Email is required',
        control: loginForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'email',
        message: 'Email is invalid',
        control: loginForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minLength',
        message: 'Email should have at least 3 symbols',
        control: loginForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Email should have maximum 360 symbols',
        control: loginForm.controls['email']
      }"
    ></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="flex flex-col mb-4">
    <label class="font-bold text-black mb-1">{{
      "AUTH.LOGIN.PASSWORD" | translate
    }}</label>

    <input
      pInputText
      class="form-control !bg-transparent"
      type="password"
      name="password"
      [attr.aria-label]="APP_NAME === 'investigator-portal' ? ('AUTH.LOGIN.PASSWORD' | translate) : null"
      autocomplete="off"
      formControlName="password"
      [ngClass]="{
        'is-invalid': loginForm.controls['password'].invalid,
        'is-valid': loginForm.controls['password'].valid
      }"
    />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Password is required',
        control: loginForm.controls['password']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Password should have at least 3 symbols',
        control: loginForm.controls['password']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Password should have maximum 100 symbols',
        control: loginForm.controls['password']
      }"
    ></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Wrapper-->
  <div class="flex font-medium mb-7 justify-end">
    <!--begin::Link-->
    <a routerLink="/auth/forgot-password">
      {{ "AUTH.LOGIN.FORGOT_PASSWORD" | translate }}
    </a>
    <!--end::Link-->
  </div>
  <!--end::Wrapper-->

  <!--begin::Action-->
  <div class="mb-4 w-full">
    <button pButton type="submit" class="w-full" [disabled]="loginForm.invalid">
      @if (isLoading$ | async) {
      <span class="indicator-progress" [style.display]="'block'">
        Please wait...
        <span class="spinner-border spinner-border-sm align-middle ml-2"></span>
      </span>
      } @if ((isLoading$ | async) === false) {
      <span class="indicator-label">{{
        "AUTH.LOGIN.CONTINUE" | translate
      }}</span>
      }
    </button>
  </div>

  <!--end::Action-->
  </form>
  } @else {
  <app-email-mfa
    [email]="mfaEmail"
    [isLoading]="(isLoading$ | async) ?? false"
    [hasError]="hasMfaError()"
    (verify)="verifyMfa($event)"
    (resend)="resendMfaCode()"
    (back)="backToLogin()"
  ></app-email-mfa>
  }
</div>

<!--end::Form-->

<!--begin::Ethniki Logo-->
@if(showEthnikiLogo) {
<div class="ethniki-slot" [class.investigator-ethniki-slot]="APP_NAME === 'investigator-portal'">
  <img
    src="../../../assets/media/logos/logo_ethniki.png"
    alt="Ethniki"
    class="ethniki-logo"
  />
</div>
}
<!--end::Ethniki Logo-->

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  @if (control.hasError(validation) && (control.dirty || control.touched)) {
  <div class="mt-2">
    <span class="text-sm text-danger">
      {{ message }}
    </span>
  </div>
  }
</ng-template>
